// extracted by mini-css-extract-plugin
var _1 = "PhoneInput_error__e3415";
var _2 = "PhoneInput_root__cb1d0";
export { _1 as "error", _2 as "root" }
